module.exports = __webpack_public_path__ + "img/s12-1-copia.d0c5383a.webp";